import { jsx as _jsx } from "react/jsx-runtime";
import selectImageTrigger from '@coolblue-development/ga4-events/triggers/ReviewPanel/selectImageTrigger';
import selectReviewImageTrigger from '@coolblue-development/ga4-events/triggers/Reviews/selectReviewImageTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { MediaGallery } from '@coolblue-development/next-patterns/client';
import { useCallback, useMemo } from 'react';
import { useTranslation } from '../../../i18n/useTranslation.js';
export const ReviewImageGallery = ({ overlayTitle, images, productFullName, maxThumbnailItems, isDrawer, onOverlayOpen, onOverlayClose, }) => {
    const { t } = useTranslation('reviews.images');
    const { trackEvent } = useAnalytics();
    const getIdFromUrl = (url) => { var _a; return (_a = url.split('/').pop()) !== null && _a !== void 0 ? _a : ''; };
    const mediaGalleryImages = useMemo(() => {
        return images
            .filter(imgUrl => getIdFromUrl(imgUrl))
            .map((imgUrl, index) => {
            return {
                type: 'ProductImage',
                label: t('label', {
                    productFullName,
                    index: index + 1,
                    total: images.length,
                }),
                url: imgUrl,
                image: {
                    id: getIdFromUrl(imgUrl),
                    fileCollection: 'review',
                },
            };
        });
    }, [images, productFullName, t]);
    const trackSelectedImageReview = useCallback((index) => {
        const eventDetails = {
            index,
            title: mediaGalleryImages[index].label,
            total_indices: mediaGalleryImages.length,
        };
        if (!isDrawer) {
            trackEvent(selectReviewImageTrigger(eventDetails));
        }
        else {
            trackEvent(selectImageTrigger(eventDetails));
        }
    }, [isDrawer, mediaGalleryImages, trackEvent]);
    return (_jsx(MediaGallery, { overlayTitle: overlayTitle, maxThumbnailItems: maxThumbnailItems, mediaGalleryItems: mediaGalleryImages, variant: "thumbnailBar", imageFit: "cover", containerSize: "small", inputType: "button", onOverlayOpen: () => onOverlayOpen === null || onOverlayOpen === void 0 ? void 0 : onOverlayOpen(), onOverlayClose: () => onOverlayClose === null || onOverlayClose === void 0 ? void 0 : onOverlayClose(), onSelectedImageChange: trackSelectedImageReview }));
};
//# sourceMappingURL=ReviewImageGallery.js.map